// 工具函数引入
import { uniqBy } from 'lodash'

// 引入所有的动态路由
import businessRoutes from '@/router/business/index' // 精彩纵横业务路由
import mainRoutes from '@/router/main/index' // 主应用路由
import performanceRoutes from '@/router/performance/index' // 采购履约路由
import wulingRoutes from '@/router/wuling/index' // 五菱业务路由

/**
 * 将主路由与各子路由配置进行合并
 * @param list
 * @returns {unknown[]|*[]}
 */
const loop = list => {
  if (!list?.length) return []

  const listTemp = uniqBy(list, 'path')
  return listTemp.map(firstRoute => {
    const pathCommonList = list.filter(route => route.path === firstRoute.path)
    list = list.filter(route => route.path !== firstRoute.path)

    if (pathCommonList.length > 1) {
      const commonChildrenList = []
      const commonObj = Object.assign({}, pathCommonList[0], {
        children: []
      })

      for (let i = 0; i < pathCommonList.length; i++) {
        commonChildrenList.push(...(pathCommonList[i].children || []))
      }
      commonObj.children = loop(commonChildrenList)

      return commonObj
    } else {
      return firstRoute
    }
  })
}

export default loop([
  ...businessRoutes,
  ...mainRoutes,
  ...performanceRoutes,
  ...wulingRoutes
])
